export default function($rootScope, $timeout, $compile, $window) {
  "ngInject";
  return function(scope, element, attrs) {

    scope.$watch(attrs.autoScrollTo, function(value) {
      if (value) {
        var pos = jQuery(value).position().top + jQuery(element).scrollTop() + 200;
        jQuery(element).animate({
            scrollTop : pos
        }, 1000);
      }
    });

  }
}



// WEBPACK FOOTER //
// ./client/app/common/directives/autoScrollTo.directive.js